/**
 * Imágenes de categorías para el paso 2 del onboarding.
 *
 * Pegar aquí las URLs finales una vez subidas a R2 o Supabase Storage.
 * Tamaño recomendado: 400×267 px (ratio 3:2), JPG optimizado, máx 80 KB.
 *
 * Si un valor está vacío (''), es null, o falla al cargar → fallback con icono.
 */
export const ONBOARDING_CATEGORY_IMAGES = {
  ropa:        'https://media.gong.cl/onboarding/ropa.jpg',
  tecnologia:  'https://media.gong.cl/onboarding/tecnologia.jpg',
  gastronomia: 'https://media.gong.cl/onboarding/gastronomia.jpg',
  belleza:     'https://media.gong.cl/onboarding/belleza.jpg',
  mascotas:    'https://media.gong.cl/onboarding/mascotas.jpg',
  floreria:    'https://media.gong.cl/onboarding/floreria.jpg',
  servicios:   'https://media.gong.cl/onboarding/servicios.jpg',
  hogar:       'https://media.gong.cl/onboarding/hogar.jpg',
};
